module.exports = __webpack_public_path__ + "static/media/main-menu.bec4fe80.wav";